import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BarChart, tasksColor, productivityColor, cycleTimesColor } from '../Shared/BarChart';
import { ProcessingTimes, CycleTimes, Wip, WipCosts, SpaceCosts, Productivity } from '../../Logic/resultResources';
import { API } from '../../Logic/API';
import { Storage } from '../../Logic/Storage';
import { RESULT_GAME_ID, RESULT_GROUP_ID } from '../../Logic/storageKeys';
import '../Spacing.css';

export class ShowGameResults extends Component {
    constructor(props) {
        super(props);

        let gameId = Storage.getValue(RESULT_GAME_ID);

        this.state = {
            gameId,
            groups: [],
            loadingGroups: true,
            isDropdownOpen: false,
            selectedGroup: { Name: "Gruppe wählen" },
            hubStarted : false,
            doNotListen: false,
            
        };

        this.props.showHostingNav(false);

        API.get(`/results/games/${gameId}/groups`)
            .then(resp => resp.json())
            .then(data => {
                this.setState({
                    groups: data,
                    loadingGroups: false
                }, () => {
                    this.setSessionGroup();
                });
            })
            .catch(e => {

            });
    }

    toggleDropdown() {
        this.setState(prevState => ({
             isDropdownOpen: !prevState.isDropdownOpen
        }));
    }

    setSessionGroup() {
        let groupId = Storage.getValue(RESULT_GROUP_ID);
        let group = this.state.groups.filter(g => g.Id === groupId);
        if (group.length === 0) {
            return;
        }
        this.selectGroup(group[0]);
    }

    selectGroup(group) {
        Storage.setSessionValue(RESULT_GROUP_ID, group.Id);
        this.setState({
            selectedGroup: group
        });
    }

    isGroupSelected() {
        return this.state.selectedGroup && this.state.selectedGroup.Id;
    }

    render() {
        let groupsDropdown = this.renderDropdown();
        let topCharts = this.renderTopCharts();
        let midCharts = this.renderMidCharts();
        let bottomCharts = this.renderBottomCharts();

        return (
            <Container>
                <Row>
                    <Col className="hidden-md" lg="1"></Col>
                    <Col xs="4" lg="3">
                        <Button color="primary" block tag={Link} to="/results">Zurück</Button>
                    </Col>
                    <Col xs="2" lg="4">
                        
                    </Col>
                    <Col xs="6" lg="3">
                        {groupsDropdown}
                    </Col>
                    <Col className="hidden-md" lg="1"></Col>
                </Row>
                <Row className="space-top" >
                    <Col className="hidden-md" lg="1"></Col>
                    {topCharts}
                    <Col className="hidden-md" lg="1"></Col>
                </Row>
                <Row className="space-top" >
                    <Col className="hidden-md" lg="1"></Col>
                    {midCharts}
                    <Col className="hidden-md" lg="1"></Col>
                </Row>
                <Row className="space-top" >
                    <Col className="hidden-md" lg="1"></Col>
                    {bottomCharts}
                    <Col className="hidden-md" lg="1"></Col>
                </Row>
            </Container>
            );
    }

    renderDropdown() {
        if (this.state.loadingGroups) {
            return this.renderLoadingDropdown();
        }
        return this.renderGroupsDropdown();
    }

    renderLoadingDropdown() {
        return (
            <Dropdown disabled toggle={() => { }}>
                <DropdownToggle caret>
                    Laden...
                    </DropdownToggle>
            </Dropdown>
            );
    }

    renderGroupsDropdown() {
        return (
            <Dropdown direction="left" isOpen={this.state.isDropdownOpen} toggle={() => this.toggleDropdown()}>
                <DropdownToggle color="primary" caret block>
                    {this.state.selectedGroup.Name}
                </DropdownToggle>
                <DropdownMenu>
                    {this.state.groups.map(g =>
                        <DropdownItem key={g.Id} onClick={() => this.selectGroup(g)}>{g.Name}</DropdownItem>
                        )}
                </DropdownMenu>
            </Dropdown>
            );
    }

    renderTopCharts() {
        return (
            <Fragment>
                {this.renderChart("Summe der Prozesszeiten", ProcessingTimes, tasksColor)}
                {this.renderChart("Produktionsleistung", Productivity, productivityColor, true)}
            </Fragment>
            );
    }

    renderMidCharts() {
        return (
            <Fragment>
                {this.renderChart("Durchlaufzeit", CycleTimes, cycleTimesColor)}
                {this.renderChart("Materialeinsatz (WIP)", Wip, tasksColor)}
            </Fragment>
        );
    }

    renderBottomCharts() {
        return (
            <Fragment>
                {this.renderChart("Platzbedarf", SpaceCosts, tasksColor)}
                {this.renderChart("Materialeinsatz (Kosten)", WipCosts, tasksColor)}
            </Fragment>
        );
    }

    renderChart(label, resource, getColor, grouped) {

        let groupId;
        if (this.isGroupSelected()) {
            groupId = this.state.selectedGroup.Id;
        }
        return (
            <Col xs="12" lg="5">
                <BarChart label={label} resource={resource} getColor={getColor} grouped={grouped} gameId={this.state.gameId} groupId={groupId} height={500} />
            </Col>
            );
    }
}


// WEBPACK FOOTER //
// ./src/components/Results/ShowGameResults.jsx